import { render, staticRenderFns } from "./StepInitBuild.vue?vue&type=template&id=8c8009a2&scoped=true&"
import script from "./StepInitBuild.vue?vue&type=script&lang=js&"
export * from "./StepInitBuild.vue?vue&type=script&lang=js&"
import style0 from "./StepInitBuild.vue?vue&type=style&index=0&id=8c8009a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8009a2",
  null
  
)

export default component.exports